import { ChangePasswordWidgetComponent } from '@baxter-jenkins/authenticator';
import { UpdateStaticInfoWidgetComponent } from '@baxter-jenkins/update-static-info-widget';
import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AngularCommonService } from '../../service/angular-common.service';
import { SecuritySettingsComponent } from '../security-settings/security-settings.component';

@Component({
  selector: 'baxter-library-profile',
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.scss']
})
export class ProfileDropdownComponent {

  @Input()
  fillColor = '#000000';

  @Input()
  gridColumnLayout = 12;

  @Input()
  navigateAfterLogout = '';

  dropdownOpen = false;

  @Input()
  darkModeService: any;

  constructor(private readonly modalService: BsModalService,
              private readonly router: Router,
              private readonly angularCommonService: AngularCommonService,
              private readonly toastr: ToastrService) {
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.angularCommonService.logout().subscribe({
      next: () => {
        this.router.navigateByUrl(this.navigateAfterLogout);
      },
      error: (err) => {
        this.router.navigateByUrl(this.navigateAfterLogout);
        console.log(err)
      },
    });
  }

  openUpdateStaticDataModal() {
    const initialState = {
      gridColumnLayout: this.gridColumnLayout
    }
    const modalRef = this.modalService.show(UpdateStaticInfoWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
      initialState
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    })
    modalRef.content.updateResultEvent.subscribe(() => {
      modalRef.hide();
      this.toastr.success('Company successfully modified');
    })
  }

  openChangePasswordModal() {
    const initialState = {
      toastr: this.toastr,
      includeModal: true,
      gridColumnLayout: AngularCommonService.config.gridColumnsSize
    }
    const modalRef = this.modalService.show(ChangePasswordWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
      initialState
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    })
  }

  openSecuritySettings() {
    const initialState = {
      toastr: this.toastr,
      includeModal: true,
      navigateAfterLogout: this.navigateAfterLogout
    }
    const modalRef = this.modalService.show(SecuritySettingsComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
      initialState
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    })
  }

  toggleDarkMode() {
    this.darkModeService.updateDarkMode();
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
}
